"use strict";
var whichTypedArray = require("which-typed-array");
module.exports = function isTypedArray(value) {
    return !!whichTypedArray(value);
};
